import { Pipe, PipeTransform } from '@angular/core';
import { PanelMenuModel } from '../contract/panel-menu-model.contract';

@Pipe({
  name: 'panelMenuModelTransform',
  standalone: true,
})
export class PanelMenuModelTransformPipe implements PipeTransform {

  transform(value: PanelMenuModel): PanelMenuModel {
    (value || []).forEach(item =>
      item.styleClass = (item?.items?.length || 0) > 0 ? '' : 'no-toggleable-content'
    );

    return value;
  }

}
